/* r15mooi: the steps thread draws once, sections below the fold rise 12 px, the photo strip gets arrows and a mouse drag */
(function () {
  if (window.ttLeven) return;
  window.ttLeven = 1;
  var d = document, rm = matchMedia('(prefers-reduced-motion: reduce)').matches, IO = window.IntersectionObserver;
  function seen(el, fn, t) {
    var o = new IO(function (e) { if (e[0].isIntersecting) { o.disconnect(); fn(); } }, { threshold: t });
    o.observe(el);
  }
  if (!rm && IO) {
    d.querySelectorAll('[data-tt-draw]').forEach(function (svg) {
      var ln = svg.querySelector('.tt-stiksel__draw'), L;
      if (!ln || !svg.getClientRects().length) return;
      L = Math.ceil(ln.getTotalLength()) + 2;
      ln.style.strokeDasharray = ln.style.strokeDashoffset = L;
      seen(svg, function () {
        svg.classList.add('is-drawn');
        requestAnimationFrame(function () { ln.style.strokeDashoffset = 0; });
        ln.ontransitionend = function () { ln.style.strokeDasharray = 'none'; };
      }, 0.6);
    });
    d.querySelectorAll('main .tt-section').forEach(function (s) {
      if (s.classList.contains('tt-hero') || s.getBoundingClientRect().top < innerHeight) return;
      s.classList.add('tt-rise');
      seen(s, function () { s.classList.add('is-in'); }, 0.08);
    });
  }
  function btn(dir, label, p) {
    return '<button type="button" class="tt-strip-nav__btn" data-dir="' + dir + '" aria-label="' + label + '"><svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><path d="' + p + '"/></svg></button>';
  }
  d.querySelectorAll('.tt-fotoband--strip').forEach(function (band) {
    var list = band.querySelector('.tt-fotoband__list'), head = band.querySelector('.tt-head'), nav = d.createElement('div'), b, x0 = null, s0, moved = 0;
    if (!list || !head) return;
    nav.className = 'tt-strip-nav';
    nav.innerHTML = btn(-1, 'Vorige foto', 'M12.5 4 6.5 10l6 6') + btn(1, 'Volgende foto', 'M7.5 4l6 6-6 6');
    head.classList.add('tt-has-nav');
    head.appendChild(nav);
    b = nav.children;
    function state() {
      b[0].disabled = list.scrollLeft < 3;
      b[1].disabled = list.scrollLeft > list.scrollWidth - list.clientWidth - 3;
    }
    nav.onclick = function (e) {
      var t = e.target.closest('button');
      if (t) list.scrollBy({ left: t.dataset.dir * list.clientWidth * 0.8, behavior: rm ? 'auto' : 'smooth' });
    };
    list.onscroll = state;
    state();
    list.onpointerdown = function (e) { if (e.pointerType == 'mouse' && !e.button) { x0 = e.clientX; s0 = list.scrollLeft; moved = 0; } };
    addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      moved = e.clientX - x0;
      if (Math.abs(moved) > 4) { list.classList.add('is-drag'); list.scrollLeft = s0 - moved; }
    });
    addEventListener('pointerup', function () { if (x0 !== null) { x0 = null; list.classList.remove('is-drag'); } });
    list.addEventListener('click', function (e) { if (Math.abs(moved) > 4) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
  });
})();
